<template>
    <div :class="styleClassGroup">


        <teaser
                :style-class="styleClassTeaser"
                v-for="item in teasers"
                :key="item.id"
                :square="square"
                :teaser="item">
        </teaser>
    </div>
</template>

<script>

    import teaser from '@/components/teaser.vue'

    export default {
        name: "teaser-group",
        components:{
            teaser
        },
        props:{
            styleClassTeaser: {
                type: String,
                required: false,
                default:''
            },
            styleClassGroup: {
                type: String,
                required: false,
                default:''
            },
            amount: {
                type: Number,
                required: false,
                default:1
            },
            teasers:{
                type:Array,
                required: true,
            },
            square:{
                type:Boolean,
                default:false,
            },
        },
        data() {
            return {
                //teasers:[]
            };
        },
        mounted() {

        },
        watch:{

        },

        computed:{

        },
        methods:{

        }

    }
</script>

<style scoped>

</style>